export function SortingByClass() {
    document.querySelectorAll(".js-sortanchor").forEach((el) => {
        el.addEventListener("click", function (e) {
            e.preventDefault();
            const term = this.getAttribute("data-sortvalue");
            const cards = document.querySelectorAll(".js-sortcard");
            cards.forEach((card) => {
                card.style.display = term === "all" || card.classList.contains(term) ? "" : "none";
            });
            document.querySelectorAll(".js-sortanchor").forEach((a) => a.classList.remove("active"));
            this.classList.add("active");
        });
    });
}
